var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]}),(_vm.show)?_vm._t("separator",function(){return [_vm._v(_vm._s(_vm.separator))]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }